var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviewDocumentsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 404 404",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.054 228.065c0 6.587 5.359 11.946 11.946 11.946s11.946-5.359 11.946-11.946-5.359-11.946-11.946-11.946-11.946 5.358-11.946 11.946z",
    fill: "current",
    className: "color000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.33 228.065c23.355 21.974 68.388 57.553 102.67 57.553s79.312-35.576 102.67-57.553c-23.358-21.977-68.387-57.553-102.67-57.553s-79.312 35.576-102.67 57.553zm142.853 0c0 22.157-18.026 40.183-40.183 40.183s-40.183-18.026-40.183-40.183 18.026-40.183 40.183-40.183 40.183 18.026 40.183 40.183zm32.98-132.53h89.403L274.077 5.929V94.45c0 .598.487 1.085 1.086 1.085z",
    fill: "current",
    className: "color000 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.84 94.449V0H49.957C41.56 0 34.753 6.807 34.753 15.204v373.591c0 8.397 6.807 15.204 15.204 15.204h304.086c8.397 0 15.204-6.807 15.204-15.204V123.772h-94.085c-16.168 0-29.322-13.154-29.322-29.323zm89.145 123.921c5.139 5.441 5.139 13.947 0 19.388-2.935 3.107-72.565 76.095-132.985 76.095S71.95 240.866 69.015 237.759c-5.139-5.441-5.139-13.947 0-19.388 2.935-3.107 72.565-76.095 132.985-76.095s130.05 72.987 132.985 76.094z",
    fill: "current",
    className: "color000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewDocumentsIcon);
export default __webpack_public_path__ + "static/media/preview-documents-icon.fbfab61d29cbb7b5efe02d007ba884c2.svg";
export { ForwardRef as ReactComponent };